import React, { Component } from 'react';
import { FaPhone } from "react-icons/fa";

export class Phone extends Component {

    constructor(props) {
        super(props);
        this.state = {
        };
    }

    render() {
        return (
            <span>
                {
                    this.props.phone
                        ? <a href={'tel:' + this.props.phone}>
                            <FaPhone />{'  '}
                            {this.props.text}
                        </a>
                        : null
                }
            </span>
        );
    }
}